"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicensePrice = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const licenses_1 = require("../../utils/licenses");
const ui_1 = require("@completeanatomy/ui");
function LicensePrice({ license }) {
    const price = (0, licenses_1.currentPriceForLicense)(license);
    if (!price) {
        return (0, jsx_runtime_1.jsx)(Price, { "data-e2e": 'LicensePrice_Price', children: "--:--" });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Price, { "data-e2e": 'LicensePrice_Price', children: price.formattedValuePrefix }), (0, jsx_runtime_1.jsxs)(PriceType, { role: "none", "aria-label": "per year", "data-e2e": 'LicensePrice_PriceType', children: [price.formattedValueSuffixIncludingSeparator
                        ? price.formattedValueSuffixIncludingSeparator
                        : '', (0, jsx_runtime_1.jsxs)("span", { "aria-hidden": "true", "data-e2e": 'LicensePrice_span', children: ["/", (0, i18n_1.Localized)((0, licenses_1.stringsForLicenseType)(license.type).period)] })] })] }));
}
exports.LicensePrice = LicensePrice;
const Price = styled_components_1.default.div `
  margin: auto 0 0 auto;

  color: ${({ theme }) => theme.text};

  font-size: 50px;
  line-height: 48px;
  text-align: center;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    font-size: 34px;
    line-height: 30px;
  `)}
`;
const PriceType = styled_components_1.default.div `
  margin: auto auto 0 0;

  color: ${({ theme }) => theme.text};

  font-size: 20px;
  text-align: left;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    font-size: 14px;
  `)}
`;
